<!-- ========== Left Sidebar Start ========== -->
<app-side-menu></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->

<!-- ============================================================== -->
<!-- Start Page Content here -->
<!-- ============================================================== -->
<div class="content-page bg-gray text-dark">
    <div class="content p-1">
        <h5 class="px-1 text-capitalize text-dark">Communication Center</h5>
        <div class="p-2 comms-list">
            <ul class="nav nav-pills bg-nav-pills nav-justified mb-3">
                <li class="nav-item">
                    <a href="#text" data-bs-toggle="tab" aria-expanded="false" class="nav-link rounded-0 active">
                        <span class="mdi mdi-home-variant d-md-none d-block"></span>
                        <span class="d-none d-md-block">Texts</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a href="#email" data-bs-toggle="tab" aria-expanded="true" class="nav-link rounded-0">
                        <span class="mdi mdi-account-circle d-md-none d-block"></span>
                        <span class="d-none d-md-block">Emails</span>
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a href="#chat" data-bs-toggle="tab" aria-expanded="false" class="nav-link rounded-0">
                        <span class="mdi mdi-settings-outline d-md-none d-block"></span>
                        <span class="d-none d-md-block">Chat</span>
                    </a>
                </li> -->
            </ul>
            <div class="tab-content">
                <div class="tab-pane show active" id="text">
                    <div class="row">
                        <div class="col-md-3">
                            <h5 class="p-0 mt-0 text-center">Conversations</h5>
                            <div class="app-search">
                                <form>
                                    <div class="mb-2 position-relative">
                                        <input type="text" class="form-control" placeholder="People, groups &amp; messages...">
                                        <span class="mdi mdi-magnify search-icon"></span>
                                    </div>
                                </form>
                            </div>
                            <div class="row people-list">
                                <div class="col-sm-12 mb-2 mb-sm-0">
                                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist"
                                        aria-orientation="vertical">
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Ranine Nasreddine</h5>
                                                        <small class="">Hey! Just checking in
                                                            again...Hey! Just checking in
                                                            again...</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 87896</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Krystle Sobh</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Zeinab Kachmar</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Mina Albarazanchi</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Joanna Sabra</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Ryan Awar</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">David Sabra</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Johnny Sabra</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Stephen Sabra</h5>
                                                        <small class="">I thought I already paid?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 12345</small>
                                                            <small>Amount Due: 5,000.00</small>
                                                            <small>Due Date: 12/1/21</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                        <a class="nav-link show text-dark" id="v-pills-home-tab" data-bs-toggle="pill"
                                            href="#v-pills-home" role="tab" aria-controls="v-pills-home"
                                            aria-selected="true">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span>
                                                <div class="row">
                                                    <div class="col-md-5">
                                                        <h5 class="p-0 m-0">Ramzi Sabra</h5>
                                                        <small class="">Can you call me please?</small>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <p class="text-right p-0 m-0 d-flex flex-column">
                                                            <small class="font-weight-bold">11/17/21 3:45 PM</small>
                                                            <small>Stock Number: 25633</small>
                                                            <small>Amount Due: 400.00</small>
                                                            <small>Due Date: 1/1/22</small>
                                                            <!-- <small>Last Payment Made: 11/1/21</small> -->
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <h5 class="p-0 mt-0 text-center">Thread</h5>
                            <div class="card">
                                <div class="card-body p-2">
                                    <ul class="conversation-list" data-simplebar="init">
                                        <div class="simplebar-wrapper" style="margin: 0px -15px;">
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask thread-list">
                                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                                    <div class="simplebar-content-wrapper"
                                                        style="height: auto; overflow: hidden scroll;">
                                                        <div class="simplebar-content" style="padding: 0px 15px;">
                                                            <li class="clearfix">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Krystle Sobh</i>
                                                                        <p>
                                                                            Hello!
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <!-- <div class="conversation-actions dropdown">
                                                                    <button class="btn btn-sm btn-link"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"><span
                                                                            class="uil uil-ellipsis-v"></span></button>

                                                                    <div class="dropdown-menu dropdown-menu-end">
                                                                        <a class="dropdown-item" href="#">Copy
                                                                            Message</a>
                                                                        <a class="dropdown-item" href="#">Edit</a>
                                                                        <a class="dropdown-item" href="#">Delete</a>
                                                                    </div>
                                                                </div> -->
                                                            </li>
                                                            <li class="clearfix odd">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Diane Sabra</i>
                                                                        <p>
                                                                            Hi, How are you? What about our next
                                                                            meeting?
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Krystle Sobh</i>
                                                                        <p>
                                                                            Yeah everything is fine
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix odd">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Diane Sabra</i>
                                                                        <p>
                                                                            Wow that's great
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Krystle Sobh</i>
                                                                        <p>
                                                                            Let's have it today if you are free
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix odd">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Diane Sabra</i>
                                                                        <p>
                                                                            Sure thing! let me know if 2pm works for you
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Krystle Sobh</i>
                                                                        <p>
                                                                            Sorry, I have another meeting scheduled at
                                                                            2pm. Can we
                                                                            have it
                                                                            at 3pm instead?
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Krystle Sobh</i>
                                                                        <p>
                                                                            We can also discuss about the presentation
                                                                            talk format
                                                                            if you have some extra mins
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="clearfix odd">
                                                                <div class="conversation-text">
                                                                    <div class="ctext-wrap">
                                                                        <i>Diane Sabra</i>
                                                                        <p>
                                                                            3pm it is. Sure, let's discuss about
                                                                            presentation
                                                                            format, it would be great to finalize today.
                                                                            I am attaching the last year format and
                                                                            assets here...
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="simplebar-placeholder" style="width: 531px; height: 924px;">
                                            </div>
                                        </div>
                                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                                        </div>
                                        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                                            <div class="simplebar-scrollbar"
                                                style="height: 312px; transform: translate3d(0px, 0px, 0px); display: block;">
                                            </div>
                                        </div>
                                    </ul>
                                    <div class="row d-flex align-items-end">
                                        <div class="col">
                                            <div class="mt-2 bg-light p-3 rounded">
                                                <form class="needs-validation" novalidate="" name="chat-form"
                                                    id="chat-form">
                                                    <div class="row">
                                                        <div class="col mb-2 mb-sm-0">
                                                            <input type="text" class="form-control border-0"
                                                                placeholder="Enter your text" required="">
                                                            <div class="invalid-feedback">
                                                                Please enter your messsage
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-auto">
                                                            <div class="btn-group">
                                                                <!-- <a href="#" class="btn btn-light"><span
                                                                        class="uil uil-paperclip"></span></a> -->
                                                                <a href="#" class="btn btn-light" title="Use Template">
                                                                    <span class="uil-upload-alt"></span>
                                                                </a>
                                                                <div class="d-grid">
                                                                    <button type="submit"
                                                                        class="btn btn-success chat-send"><span
                                                                            class="uil uil-message"></span></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <h5 class="p-0 mt-0 text-center">Sale Information</h5>
                            <ul>
                                <li>Stock Number: 12345</li>
                                <li>Year: 2017</li>
                                <li>Make: Honda</li>
                                <li>Model: CR-V</li>
                                <li>VIN: 23VJ49VJRIM30EN</li>
                                <li>Sale Date: 1/1/2021</li>
                                <li>Amount Due: 156.67</li>
                                <li>Date Due: 156.67</li>
                                <li>Previous Amount Paid: 156.67</li>
                                <li>Previous Date Paid: 12/1/21</li>
                                <li>Payoff Amount: 13,245.34</li>
                                <li>Salesperson: Erick Mata</li>
                                <li>Assigned Collector: Masar Rahma</li>
                            </ul>
                            <div class="d-flex justify-content-center">
                                <button type="button" class="btn btn-primary m-1">Collection Center</button>
                                <button type="button" class="btn btn-primary m-1">View Sale</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" id="email">
                </div>
                <!-- <div class="tab-pane" id="chat">
                    <p>...</p>
                </div> -->
            </div>

        </div>
    </div>
</div>
